
export { default as Logo } from "./footer_logo.png";
export { default as BhipLogo } from "./bhip-logo.svg";
export { default as MainImage } from "./homeBannernew.jpg";
export { default as MainImageNew } from "./newBannerHome.png";
export { default as videoImage } from "./video-image.jpg";
export { default as legacyImage } from "./legacy-image.jpg";
export { default as Faimly } from "./faimly.jpg";
export { default as runningImage } from "./running.jpg";
export { default as footerLastImage } from "./footer-last.jpg";
export { default as outspoken1 } from "./outspoken1.jpg";
export { default as outspoken2 } from "./outspoken2.jpg";
export { default as WomenImage } from "./Women-image.jpg";
export { default as product1 } from "./product1.png";
export { default as whitelogo } from "./whitelogo.png";
export { default as b_logo } from "./b_logo.png";
export { default as homebanner3 } from "./homebanner3.jpg";
export { default as oneWoman } from "./one-woman.jpg";
export { default as twoWomen } from "./two-women.jpg";
export { default as Icon1 } from "./icon1.png";
export { default as Icon2 } from "./icon2.png";
export { default as Icon3 } from "./icon3.png";
export { default as Icon4 } from "./icon4.png";
export { default as Icon5 } from "./icon5.png";
export { default as Icon6 } from "./icon6.png";
export { default as Icon7 } from "./icon7.png";
export { default as Icon8 } from "./icon8.png";
export { default as Icon9 } from "./icon9.png";
export { default as threeWomen } from "./three-women.jpg";
export { default as aboutFirstImage } from "./about-banner.jpg";
export { default as aboutSecondImage } from "./about-2nd-img.jpg";
export { default as ourVision } from "./our-vision.jpg";
export { default as footerLastImage2 } from "./footer-above.jpg";
export { default as notFoundImage } from './notFound.png';
export { default as empowerPeople } from './empower-people.jpg';
export { default as twoPeople } from './two-people.jpg';
export { default as teachPeople } from './teach-people.jpg';
export { default as qualifyPeople } from './qualify-people.jpg';
export { default as activatePeople } from './activate-people.jpg';
export { default as joinMember } from './join-member.jpg';
export { default as menSitting } from './men-sitting.jpg';
export { default as lifeStyleBanner } from './lifestyle-banner.jpg';
export { default as vision } from './vision.jpg';
export { default as vision2 } from './vision-2.jpg';
export { default as bhipallproducts } from './bhipallproducts.jpg';
export { default as ProductsBanner } from './products_banner.jpg';
export { default as bhipnonipage } from './bhipNonipage.jpg';
export { default as bhipLifestyle } from './bhipLifestyle.jpg';
export { default as fivePeople } from './five-people.jpg';
export { default as LifeStylebackgroud } from './bhiplifeStyle2.png';
export { default as black_logo } from './logo-b.png';
export { default as Tick } from './tickimg.png';
export { default as CheckArrow } from './check-arrow.png';
export { default as ourstory } from './our-story-banner.jpg';
export { default as aboutUsNewBanner } from './about_us_new_banner.jpg';
export { default as Aboutbackground } from './Aboutbackground.png';
export { default as aboutUsNewBanner2 } from './about_us_new_banner2.jpg'
export { default as Face } from './face-3.png'
export { default as Bflex } from './b-flex.png'
export { default as img2 } from './img-2.png'
export { default as img3 } from './img-3.png'
export { default as img4 } from './img-4.png'
export { default as img5 } from './img-5.png'
export { default as cartImg } from './cart-dd.png'
export { default as Gurant } from './gurant.png'
export { default as Lock } from './lock-img.png'
export { default as useImg } from './use-img.jpg'
export { default as custOne } from './cust_1.jpg'
export { default as custTwo } from './cust_2.jpg'
export { default as starMain } from './start_black.png'
export { default as userIcon } from './user-icon.png'
export { default as chooseBhip } from './choose_bhip.jpg'
export { default as produtImg } from './product-img.png'
export { default as mailIcon } from './mail-icon.png'
export { default as searchIcon } from './search-icon.png'
export { default as cartIcon } from './cart_icon_head.png'






